<template>
  <PopUp
    v-if="isProSuccessPopupVisible"
    :max-height="90"
    close-button
    close-button-variant="black"
    @close="closeProSuccessPopup"
  >
    <div class="upgrade-popup">
      <div class="upgrade-popup__image pro-success">
        <div class="text-over">
          <img
            class="lock"
            src="@/assets/icons/optimized/dashboard/upgrade/lock-icon.png"
            alt="Lock icon"
          >
          <div>You`re in!</div>
        </div>
      </div>
      <div class="upgrade-popup__main-block">
        <div class="upgrade-popup__title">Welcome to Pro, you’ve just unlocked all of these amazing
          features:
        </div>
        <ul class="upgrade-popup__items">
          <li
            class="upgrade-popup__item"
            v-for="(benefit,index) in upgradeBenefits"
            :key="index"
          >
            <img
              class="item__icon"
              :src="benefit.icon"
              :alt="benefit.alt"
            >
            <div class="item__text">{{ benefit.text }}</div>
          </li>
        </ul>
        <a
          @click="closeProSuccessPopup"
          class="button-brand upgrade-popup__button"
        >Go to dashboard
        </a>
      </div>
    </div>
  </PopUp>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import PopUp from '@/components/PopUp';

export default {
  name: 'ProSuccessPopup',
  components: { PopUp },
  computed: {
    ...mapGetters({
      isProSuccessPopupVisible: 'isProSuccessPopupVisible',
    }),
    upgradeBenefits() {
      return [
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/customization.svg'),
          text: 'Advanced page customisation',
          alt: 'Customization icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/analytics.svg'),
          text: 'Advanced analytics',
          alt: 'Analytics icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/access.svg'),
          text: '50GB storage space',
          alt: 'Upload icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/build.svg'),
          text: 'Course building templates',
          alt: 'Build icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/mailchimp.svg'),
          text: 'Mailchimp integration',
          alt: 'Mailchimp icon',
        },
        {
          icon: require('@/assets/icons/optimized/dashboard/upgrade/present.svg'),
          text: 'Plus loads more',
          alt: 'Present icon',
        },
      ];
    },
  },
  methods: {
    ...mapMutations({
      closeProSuccessPopup: 'closeProSuccessPopup',
    }),
  },
};
</script>
